// This file defines global Publish/Subscribe pattern. It's used to enable communication between different components across the theme

// Constant defining the debounce time for input change events.
const ON_CHANGE_DEBOUNCE_TIMER = 300;

// Object containing a defined list of all event names used across the theme.
const PUB_SUB_EVENTS = {
  cartAdd: 'cart-add', // Fired when an item is successfully added to the cart.
  cartUpdate: 'cart-update', // Fired when the cart contents or attributes are updated.
  bundleUpdate: 'bundle-update', // Fired when a product bundle option changes.
  resetOptions: 'reset-options', // Fired to reset product option states.
  openFilterTab: 'open-filter-tab', // Fired to open a specific filter tab.
  closeFilterDrawer: 'close-filter-drawer', // Fired to close the product filter drawer.
  upsellsUpdate: 'upsells-update', // Fired when upsell content needs to be refreshed.
  modalOpen: 'modal-open', // Fired when any modal window opens.
  modalClose: 'modal-close' // Fired when any modal window closes.
};

// Global object to store lists of callback functions (subscribers) keyed by event name.
let subscribers = {};

/*
 * Subscripe to a specific event.
 * @param {string} eventName - The name of the event to listen for (must be a key from PUB_SUB_EVENTS).
 * @param {function} callback - The function to execute when the event is published.
 * @returns {function} A function that, when called, unsubscribes the callback.
 */
function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter(cb => {
      return cb !== callback;
    });
  };
}

/*
 * Publish an event.
 * @param {string} eventName - The name of the event to publish.
 * @param {any} [data] - Optional data payload to pass to the callbacks.
 */
function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach(callback => {
      callback(data);
    });
  }
}
